$(function() {
	// alert('header script');
})